function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,88.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 440 l0 -440 560 0 560 0 0 440 0 440 -560 0 -560 0 0 -440z m1090 0 l0 -400 -525 0 -525 0 0 400 0 400 525 0 525 0 0 -400z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220 600 l0 -60 80 0 80 0 0 -160 0 -160 60 0 60 0 0 220 0 220 -140 0 -140 0 0 -60z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630 440 l0 -220 140 0 140 0 0 60 0 60 -80 0 -80 0 0 160 0 160 -60 0 -60 0 0 -220z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1470 608 l0 -53 62 0 63 0 3 -167 2 -168 60 0 60 0 0 171 0 170 63 -2 62 -3 0 50 0 49 -187 3 -188 2 0 -52z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2095 648 c-2 -7 -38 -104 -80 -216 -41 -111 -75 -205 -75 -207 0 -3 28 -5 63 -5 l63 0 10 38 9 37 64 0 64 0 12 -35 c12 -34 13 -35 73 -38 34 -2 62 -1 62 2 0 4 -130 354 -155 419 -6 13 -19 17 -56 17 -31 0 -51 -5 -54 -12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2530 440 l0 -220 60 0 60 0 0 64 0 64 53 4 c28 2 65 11 82 19 36 17 70 67 79 115 9 47 -26 120 -73 151 -30 21 -46 23 -147 23 l-114 0 0 -220z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3040 440 l0 -220 160 0 160 0 0 50 0 49 -97 3 -98 3 -3 168 -2 167 -60 0 -60 0 0 -220z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3440 655 c0 -3 32 -68 70 -145 68 -136 70 -142 70 -215 l0 -75 65 0 65 0 0 76 c0 76 1 79 74 221 l75 144 -67 -3 -66 -3 -36 -83 c-20 -46 -40 -84 -45 -84 -6 0 -26 39 -45 86 l-35 86 -62 0 c-35 0 -63 -2 -63 -5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3980 610 l0 -50 65 0 65 0 0 -170 0 -170 60 0 60 0 2 168 3 167 63 0 62 0 0 53 0 52 -190 0 -190 0 0 -50z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4537 653 c-4 -3 -7 -102 -7 -220 l0 -213 60 0 60 0 0 220 0 220 -53 0 c-30 0 -57 -3 -60 -7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4950 638 c-25 -14 -58 -44 -75 -67 -27 -39 -30 -50 -30 -125 0 -75 3 -87 30 -132 58 -93 174 -126 272 -76 37 20 73 55 73 73 0 4 -20 19 -44 33 l-45 26 -25 -25 c-62 -61 -146 -7 -146 95 0 103 79 150 147 87 l22 -20 41 27 c49 32 49 48 -3 90 -32 26 -48 31 -105 34 -56 3 -74 0 -112 -20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5463 644 c-46 -23 -73 -71 -73 -129 0 -41 5 -52 34 -79 20 -19 58 -39 95 -51 63 -19 88 -36 76 -55 -10 -16 -59 -12 -120 11 -31 12 -58 19 -59 17 -14 -15 -46 -91 -41 -98 8 -12 92 -38 150 -46 101 -12 186 34 200 109 16 83 -19 127 -130 166 -83 30 -107 55 -63 66 21 5 61 -5 120 -29 13 -6 22 3 42 43 l26 50 -56 20 c-66 25 -156 27 -201 5z"
}));

const SvgTaplytics = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "573.000000pt",
  height: "88.000000pt",
  viewBox: "0 0 573.000000 88.000000",
  preserveAspectRatio: "xMidYMid meet",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTaplytics, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/taplytics.e04760d6.svg";
export { ForwardRef as ReactComponent };